import client from './client'

export const fetchPackages = () => client.get('/packages')

export const fetchPackageById = (id) => client.get(`/packages/${id}`)
